// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_650a3","row":"_05f08","content":"_69b53"};